import React, { useEffect, useState } from "react";
import { useCookieConsent } from "../context/CookieConsentContext";
import "../styles/cookies.css";

export default function CookieSettingsModal() {
  const { settingsOpen, setSettingsOpen, consent, savePreferences, rejectAll } = useCookieConsent();

  const [prefs, setPrefs] = useState(consent);

  useEffect(() => {
    if (settingsOpen) {
      setPrefs(consent);
    }
  }, [settingsOpen, consent]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape" && settingsOpen) {
        setSettingsOpen(false);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [settingsOpen, setSettingsOpen]);

  if (!settingsOpen) return null;

  const handleChange = (key) => {
    setPrefs((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = () => {
    savePreferences({
      essential: true,
      analytics: !!prefs.analytics,
      marketing: !!prefs.marketing,
      functional: !!prefs.functional,
    });
  };

  return (
    <div className="cookie-modal" role="dialog" aria-modal="true" aria-label="Configuración de cookies">
      <div className="cookie-modal__backdrop" onClick={() => setSettingsOpen(false)} />

      <div className="cookie-modal__panel">
        <button
          type="button"
          className="cookie-modal__close"
          onClick={() => setSettingsOpen(false)}
          aria-label="Cerrar"
        >
          ×
        </button>

        <h2 className="cookie-modal__title">Configuración de cookies</h2>

        <div className="cookie-option">
          <div>
            <h3>Cookies esenciales</h3>
            <p>
              Permiten funciones básicas como seguridad, verificación de identidad y navegación.
            </p>
          </div>
          <label className="cookie-switch cookie-switch--disabled">
            <input type="checkbox" checked disabled readOnly />
            <span />
          </label>
        </div>

        <div className="cookie-option">
          <div>
            <h3>Cookies analíticas</h3>
            <p>
              Nos ayudan a entender cómo navegan los usuarios y mejorar la experiencia.
            </p>
          </div>
          <label className="cookie-switch">
            <input
              type="checkbox"
              checked={!!prefs.analytics}
              onChange={() => handleChange("analytics")}
            />
            <span />
          </label>
        </div>

        <div className="cookie-option">
          <div>
            <h3>Cookies de marketing</h3>
            <p>
              Se utilizan para medir campañas y mostrar anuncios más relevantes.
            </p>
          </div>
          <label className="cookie-switch">
            <input
              type="checkbox"
              checked={!!prefs.marketing}
              onChange={() => handleChange("marketing")}
            />
            <span />
          </label>
        </div>

        <div className="cookie-option">
          <div>
            <h3>Cookies funcionales</h3>
            <p>Recuerdan preferencias como idioma o configuraciones de uso.</p>
          </div>
          <label className="cookie-switch">
            <input
              type="checkbox"
              checked={!!prefs.functional}
              onChange={() => handleChange("functional")}
            />
            <span />
          </label>
        </div>

        <div className="cookie-modal__footer">
          <button type="button" className="cookie-btn cookie-btn--ghost" onClick={rejectAll}>
            Rechazar todo
          </button>
          <button type="button" className="cookie-btn cookie-btn--primary" onClick={handleSave}>
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}